/**
 * Details are here
 * https://help.twilio.com/articles/4407882914971-Comparison-between-Starter-Low-Volume-Standard-and-Standard-registration-for-A2P-10DLC
 */
export enum TwilioBrandRegistrationType {
  LOW_VOLUME = 'lowVolume',
  STANDARD = 'standard',
}
